import * as types from './mutation-types'

export default {
    [types.SET_SETTLEMENTS](state, settlements) {
        state.settlements = settlements
    },

    [types.SET_TOTAL_SETTLEMENTS](state, totalSettlements) {
        state.totalSettlements = totalSettlements
    },

    [types.ADD_SETTLEMENT](state, data) {
        state.settlements.push(data)
    },

    [types.SET_SELECTED_SETTLEMENTS](state, data) {
        state.selectedSettlements = data
    },

    [types.SET_SELECT_ALL_STATE](state, data) {
        state.selectAllField = data
    },
}
